import { FLAGSMITH_KEYS } from './key';
import { useGetFlagValue } from './useGetFlagValue';

/**
 * Single source of truth for the EZ File UI feature flag.
 * `true` → new FinancialAid step UI + its layout chrome (dark bg, wide
 * container, hidden progress bar, suppressed shell partnership chip).
 * `false` → legacy step UI with the original layout chrome.
 */
export const useIsNewEzFileUi = (): boolean => {
  const { enable, value, ready } = useGetFlagValue(FLAGSMITH_KEYS.EZ_FILE);

  return ready && enable && value === true;
};
